
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/[vendorId]/account/subscriptions",
      function () {
        return require("private-next-pages/dashboard/[vendorId]/account/subscriptions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/[vendorId]/account/subscriptions"])
      });
    }
  